var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"uGo7ZY4GtiHZGFTmRDx5J"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["storefront@nyati-mexico-sa-de-cv"]={id:"uGo7ZY4GtiHZGFTmRDx5J"};
      